import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  RECEIVE_COMMENTS,
  ADD_COMMENT,
  CACHE_COMMENT
} from '../actions/comments'

export default handleActions({
  [RECEIVE_COMMENTS]: (state, action) => {
    return action.payload
  },
  [ADD_COMMENT]: (state, action) => {
    return update(state, {
      items: {
        $push: [action.payload]
      }
    })
  },
  [CACHE_COMMENT]: (state, action) => {
    return update(state, {
      cache: {$set: action.payload}
    })
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/comments.js